import { t as o } from "./to-object.js";
import { t as r } from "./to-absolute-index.js";
import { l as t } from "./length-of-array-like.js";
var a = function a(_a) {
  for (var i = o(this), s = t(i), e = arguments.length, l = r(e > 1 ? arguments[1] : void 0, s), f = e > 2 ? arguments[2] : void 0, m = void 0 === f ? s : r(f, s); m > l;) i[l++] = _a;
  return i;
};
export { a };